import {
  Avatar,
  Button,
  Center,
  FileButton,
  Stack,
  Text,
  Title,
  UnstyledButton,
  Checkbox,
  Paper,
  Group,
  Divider,
  SimpleGrid,
} from "@mantine/core";
import React, { useEffect, useState } from "react";

const SelectComponent = ({ label, selected, onChange }) => {
  return (
    <UnstyledButton
      onClick={() => onChange(label)}
      className={`group relative flex w-full items-center gap-4 rounded-xl border border-gray-400 bg-white p-4 shadow-sm transition-all hover:border-indigo-300 focus:outline-none focus:ring-2 focus:ring-indigo-300 ${
        selected ? "border-indigo-400 ring-2 ring-indigo-300" : "border-gray-400"
      }`}
      aria-pressed={selected}
    >
      {/* Left Checkbox */}
      <Checkbox
        checked={selected}
        onChange={onChange}
        tabIndex={-1}
        size="md"
        styles={{ input: { cursor: "pointer" } }}
        aria-hidden
        color="indigo"
        radius='xl'
      />

      {/* Label & Description */}
      <div className="flex flex-col">
        <Text fw={700} size="sm" className="text-gray-800">
          {label}
        </Text>
      </div>

    </UnstyledButton>
  );
};

export default function Category({ form }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const selects = ["Professional", "Freelance", "Investor", "Student"];

  useEffect(() => {
    if (form.values.avatar)
      setSelectedImage(URL.createObjectURL(form.values.avatar));
  }, []);

  const handleImageUpload = (file) => {
    if (file) {
      form.setFieldValue("avatar", file);
      setSelectedImage(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <Title order={3} className="my-2">Add a profile picture</Title>
      <Paper withBorder radius="md" className="p-4 sm:p-5 mb-4">
        <Center>
          <Stack spacing="sm" align="center">
            <Avatar
              variant="outline"
              radius="xl"
              size="140px"
              color="indigo"
              src={selectedImage}
            />
            <Group spacing="sm">
              <FileButton
                variant="light"
                color="indigo"
                onChange={handleImageUpload}
                size="sm"
                defaultValue={""}
                accept="image/png,image/jpeg,image/jpg"
                errors={form.errors.avatar}
              >
                {function (props) {
                  return <Button {...props}>Upload image</Button>;
                }}
              </FileButton>
            </Group>
            <Text size="xs" color="dimmed">
              PNG or JPG up to 5MB. Square images work best.
            </Text>
            {form.errors.avatar && (
              <Text size="sm" color="red">
                {form.errors.avatar}
              </Text>
            )}
          </Stack>
        </Center>
      </Paper>

      <Title order={3} className="my-2">Who are you?</Title>
      <Text size="sm" className="mb-2 text-gray-600">
        Choose your user type to tailor your experience. Whether you're a
        student, freelance enthusiast, or seasoned professional, your selection
        helps us provide personalized content and services just for you.
      </Text>
      <Paper withBorder radius="md" className="p-4 sm:p-5">
        <SimpleGrid cols={2} spacing="md" breakpoints={[{ maxWidth: "sm", cols: 1 }]}>
          {selects.map((select, index) => (
            <SelectComponent
              key={index}
              label={select}
              selected={selects[form.values.user_type] === select}
              onChange={(event) => {
                form.setFieldValue("user_type", index);
              }}
            />
          ))}
        </SimpleGrid>
        <Center>
          <Text color="red" size="sm" align="center" className="mt-2">
            {form.errors.user_type}
          </Text>
        </Center>
      </Paper>
    </>
  );
}
